import {ProfileModel} from "../../features/profile/profileTypes";
import EditIcon from "./EditIcon";
import React from "react";

type Props = {
    profile: ProfileModel
};

const UserInfoList = ({profile}: Props) => {
    const dataToDisplay = [
        profile.country.name,
        profile.city,
        profile.gender?.name,
        profile.wheel
    ].filter(n => n);

    return (
        <div className='user-info-list text-center editable slide-left'>
            <span>{dataToDisplay.join(' ● ')}</span><EditIcon />
        </div>
    )
}

export default UserInfoList;
